<template>
  <div class="google-maps-modal">
    <transition class="modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">
            <div class="panel-header">
              <img class="modal-icon close-icon" src="https://assets.autoalert.com/img/autoalert-icons/icon-close-or-remove-lake.svg" @click="closeModal">
              Location
            </div>
            <div class="modal-body">
              <!-- DO NOT REMOVE THE BELOW INPUT CONTROL; IT'LL BE USED FOR DEBUGGING PURPOSES -->
              <!-- <input type="text" class="form-control btn-block mb-3" placeholder="Search Place" v-model="placesSearchText" @keyup.enter="searchPlaces" /> -->
              <div class="root-google-map" id="rootGoogleMap"></div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import debounce from "debounce";
import { mapState } from "vuex";

export default {
  name: "googleMapsModal",
  data() {
    return {
      placesSearchText: null,
      map: null,
      API_KEY: null,
    };
  },
  computed: {
    ...mapState({
      ShowGoogleMapsModal: (state) => state.GoogleMaps.ShowGoogleMapsModal,
      GoogleMapsInfo: (state) => state.GoogleMaps.GoogleMapsInfo,
      GOOGLE_MAPS_API_KEY: (state) => state.GoogleMaps.GOOGLE_MAPS_API_KEY,
    }),
  },
  watch: {
    GoogleMapsInfo(newVal) {
      if (newVal) {
        this.placesSearchText = newVal;
        this.searchPlaces();
      }
    },
  },
  mounted() {
    this.API_KEY = this.GOOGLE_MAPS_API_KEY;
    window.initMap = this.initMap;
    let scriptUrl = `https://maps.googleapis.com/maps/api/js?key=${this.API_KEY}&loading=async&libraries=places&callback=initMap`;
    let script = document.head.querySelector(`script[src="${scriptUrl}"]`);
    if (!script) {
      script = document.createElement("script");
      script.src = scriptUrl;
      script.async = true;
      document.head.appendChild(script);
    }
  },
  methods: {
    async initMap() {
      const { Map } = await google.maps.importLibrary("maps");
      const kansasCity = new google.maps.LatLng(39.10108, -94.58525);
      this.map = new Map(document.getElementById("rootGoogleMap"), {
        center: kansasCity,
        zoom: 8,
        mapId: "DEMO_MAP_ID",
        maxZoom: 15,
        minZoom: 2,
      });
    },
    searchPlaces: debounce(async function () {
      let markers = {};
      if (!this.placesSearchText || !this.placesSearchText.trim()) return;
      const { Place } = await google.maps.importLibrary("places");
      const { AdvancedMarkerElement } = await google.maps.importLibrary(
        "marker"
      );
      const request = {
        textQuery: this.placesSearchText,
        fields: ["displayName", "location"],
        includedType: "", // Restrict query to a specific type (leave blank for any).
        useStrictTypeFiltering: true,
        locationBias: this.map.center,
        isOpenNow: true,
        language: "en-US",
        maxResultCount: 1,
        minRating: 1, // Specify a minimum rating.
        region: "us",
      };
      const { places } = await Place.searchByText(request);
      if (places.length) {
        const { LatLngBounds } = await google.maps.importLibrary("core");
        const bounds = new LatLngBounds();
        // First remove all existing markers.
        for (const id in markers) {
          markers[id].map = null;
        }
        markers = {};
        // Loop through and get all the results.
        places.forEach((place) => {
          const marker = new AdvancedMarkerElement({
            map: this.map,
            position: place.location,
            title: place.displayName,
          });
          markers[place.id] = marker;
          marker.addListener("gmp-click", () => {
            map.panTo(place.location);
            updateInfoWindow(place.displayName, place.id, marker);
          });
          if (place.location != null) {
            bounds.extend(place.location);
          }
        });
        this.map.fitBounds(bounds, 50);
      } else {
        console.log("No results");
      }
    }, 300),
    closeModal() {
      this.$store.dispatch("closeGoogleMapsModal");
    },
  },
};
</script>

<style lang="scss" scoped>
.google-maps-modal {
  height: auto;

  .modal-container {
    .panel-header {
      .modal-icon {
        height: 30px;
        width: auto;
        vertical-align: bottom;

        &.close-icon {
          float: right;
          cursor: pointer;
        }
      }
    }

    .modal-body {
      .root-google-map {
        border: 1px solid $gray-lt;
        width: 100%;
        height: 75vh;
        max-height: 500px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/modals/GoogleMapsModal.vue